import React, { Component } from 'react';
import './style.css'; // css file
import { Route, Switch, Redirect } from 'react-router-dom';
import { Spinner } from 'reactstrap';
import firebase from 'firebase/app';
import StyledFirebaseAuth from 'react-firebaseui/StyledFirebaseAuth';

// Local Components
import { NavigationBar } from './Components/NavigationBar.js';
import { CarouselDisplay } from './Components/CarousalDisplay.js';
import { FeaturedPrograms } from './Components/FeaturedPrograms.js';
import { Events } from './Components/Events.js';
import { Footer } from './Components/Footer.js';
import { ProgramDetailPage } from './Components/ProgramDetailPage.js';
import { OurStory, WhatWePropose } from './Components/AboutPage';
import { HowSpeNeedsWorks } from './Components/HowSpeNeedsWorks.js';
import { PolicyOrgPage } from './Components/PolicyOrgPage.js';
import { PolicyPage } from './Components/PolicyPage.js';
import { Faqs } from './Components/Faqs.js';
import { MyPage } from './Components/MyPage';
import { MyOrgPage } from './Components/MyOrgPage.js';

// Applicaiton Class
class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      isloaded: false,

      firebaseData: {
        programs: [], // all programs
        events: [], // all events
        organizations: [] // all organizations
      },

      allData: {},

      logInMember: false, // save users log-in status
      logInOrg: false,

      userData: {
        fav: [], // member's favorite programs
        favKey: [] // key for favorite programs
      },

      user: null, // firebase user
    };
  }

  uiConfig = {
    signInOptions: [
      firebase.auth.GoogleAuthProvider.PROVIDER_ID
    ],
    signInFlow: 'popup',
  }

  componentDidMount() {
    firebase.auth().signOut() // a default setting: if the user refreshes the page, they will need to be re-logged-in

    // load events data here
    let eventsRef = firebase.database().ref('allData/events');
    eventsRef.on('value', (snapshot) => {
      let value = snapshot.val();
      let dbEvents = [];
      if (value !== undefined & value !== null) {
        let eventsKeys = Object.keys(value);
        dbEvents = eventsKeys.map((singleKey) => { // turn objects from firebase into arrays
          return { id: singleKey, ...value[singleKey] }
        })
      }

      // set load event data to firebaseData
      this.setState(prevState => ({
        firebaseData: {
          ...prevState.firebaseData,
          events: dbEvents
        }
      }))
    })

    // load programs data here
    let programsRef = firebase.database().ref('allData/programs');
    programsRef.on('value', (snapshot) => {
      let value = snapshot.val();
      let dbPrograms = [];
      if (value !== undefined & value !== null) {
        let programsKey = Object.keys(value);
        dbPrograms = programsKey.map((singleKey) => {
          return { id: singleKey, ...value[singleKey] }
        })
        this.setState({ isloaded: true })
      }

      this.setState(prevState => ({
        firebaseData: {
          ...prevState.firebaseData,
          programs: dbPrograms
        }
      }))
    })

    // load organizers data here
    let organizerRef = firebase.database().ref('allData/organizers');
    organizerRef.on('value', (snapshot) => {
      let value = snapshot.val();
      let dbOrganizers = [];
      if (value !== undefined & value !== null) {
        let organizerKey = Object.keys(value);
        dbOrganizers = organizerKey.map((singleKey) => {
          return { id: singleKey, ...value[singleKey] }
        })
      }

      this.setState(prevState => ({
        firebaseData: {
          ...prevState.firebaseData,
          organizers: dbOrganizers
        }
      }))
    })

    this.authUnRegFunc = firebase.auth().onAuthStateChanged((firebaseUser) => {
      // if a user signs in
      if (firebaseUser !== null) {
        this.setState({ user: firebaseUser })
        // if a member signs in
        if (this.state.logInMember) {
          let memRef = firebase.database().ref('members/' + this.state.user.uid);

          // listen to later changes in member state
          memRef.on("value", snapshot => {
            // if a new member signs in
            if (!snapshot.exists()) {
              memRef.set({ //add a new entry to `members`
                name: this.state.user.displayName,
                email: this.state.user.email,
                uid: this.state.user.uid,
                fav: [], // favorite program
                questions: [] // favorite question
              });
            }

            let value = snapshot.val();

            if (value !== null) {
              // if the member had favorited before
              if (value.fav !== undefined & value.fav !== null) {
                let favKey = Object.keys(value.fav);
                let dbFav = favKey.map((item) => {
                  return value.fav[item];
                })
                // updates saved info from database to state
                this.setState(prevState => ({
                  userData: {
                    ...prevState.firebaseData,
                    fav: dbFav,
                    favKey: favKey
                  }
                }))
              } else {
                this.setState(prevState => ({
                  userData: {
                    ...prevState.firebaseData,
                    fav: [],
                    favKey: []
                  }
                }))
              }
            }
          })
          // if an organziation signs in
        } else if (this.state.logInOrg) {
          let orgRef = firebase.database().ref('organizations/' + this.state.user.uid);

          orgRef.once("value", snapshot => {
            // if a new organization signs in
            if (!snapshot.exists()) {
              orgRef.set({ //add a new entry to `organizations`
                organizer: this.state.user.displayName,
                email: this.state.user.email,
                uid: this.state.user.uid,
              });

              firebase.database().ref('allData/organizers/' + this.state.user.uid).set({ //add a new entry to `organizers`
                organizer: this.state.user.displayName,
                email: this.state.user.email,
                uid: this.state.user.uid,
              });
            }
            // updates saved info from database to state
            this.setState({ userData: snapshot.val() })

          });
        }
        // if a user signs out
      } else {
        this.setState({ user: null, logInMember: false, logInOrg: false })
      }
    })
  }

  componentWillUnmount() {
    this.authUnRegFunc();
  }

  handleSignOut = () => {
    firebase.auth().signOut()
  }

  memberSignIn = () => {
    this.setState({ logInMember: true });
  }

  orgSignIn = () => {
    this.setState({ logInOrg: true });
  }



  saveFav = (programID) => {
    let favRef = firebase.database().ref('members/' + this.state.user.uid + '/fav');
    // if the user had favorited any programs before
    if (this.state.userData.fav.length > 0) {
      let index = this.state.userData.fav.indexOf(programID); //return index
      if (index > -1) { // if the user had favorited this program before
        firebase.database().ref('members/' + this.state.user.uid + '/fav/' + this.state.userData.favKey[index]).remove();
      } else {
        favRef.push(programID);
      }
    } else {
      favRef.push(programID);
    }
  }

  // upload program to the database
  writeNewProgram = (programDetails) => {
    // Get a key for a new Program.
    let newPostKey = firebase.database().ref().child('programs').push().key;

    let programData = {
      id: newPostKey, //save the post key inside the program as id
      src: programDetails.src,
      altText: programDetails.altText,
      caption: programDetails.caption.substr(0, 200) + "...",
      description: programDetails.caption,
      header: programDetails.header,
      longDescription: programDetails.longDescription,
      tags: Object.assign({}, programDetails.tags),
      trainingAreas: this.turnStringIntoObject(programDetails.trainingAreas),
      audience: this.turnStringIntoObject(programDetails.audience),
      clientRatio: this.turnStringIntoObject(programDetails.clientRatio),
      operatingHours: this.turnStringIntoObject(programDetails.operatingHours),
      QAQuestions: {
        0: { 0: "What is the price for this program?", 1: "Our price varies depend on how many parts of program you would like to choose. Plese state the specific program in your contact email." },
        1: { 0: "Who should I contact if I would like to volunteer for this program?", 1: "Please Email the contact for your corresponding location. We would direct you from there." }
      },
      contact: programDetails.contact, // name: [[phone, email], [phone, email]], name: [[phone, email]]
      organizer: this.state.user.uid //later change to current organization ID
    };

    // Write the new post's data simultaneously to the posts list and the user's post list.
    let updates = {};
    updates['/allData/programs/' + newPostKey] = programData;

    return firebase.database().ref().update(updates);
  }

  turnStringIntoObject = (string) => {
    let newString = String(string);
    let object;
    if (newString.length <= 0 | newString === "") {
      object = "";
    } else {
      object = Object.assign({}, this.makeArray(newString));
    }
    return object;
  }

  makeArray = (v) => {
    let txtArray = v.split('\n');
    return txtArray.filter(txt => txt !== "");
  }

  removeEvent = (eventId) => {
    return firebase.database().ref('allData/events/' + eventId).remove();
  }

  removeProgram = (programID) => {
    return firebase.database().ref('allData/programs/' + programID).remove();
  }

  render() {
    let allData = this.state.allData;
    let firebaseData = this.state.firebaseData;
    let content = null;
    let fav;
    if (this.state.logInMember) {
      fav = this.state.userData.fav;
    }

    // if no user is currently signed in and a member or an organization wants to sign in, take them to the sign-in page
    if ((this.state.logInMember && this.state.user === null) || (this.state.logInOrg && this.state.user === null)) {
      content = <StyledFirebaseAuth uiConfig={this.uiConfig} firebaseAuth={firebase.auth()} />
    } else {
      // otherwise display home page
      content = (
        <div>
          <header>
            <NavigationBar
              logInMember={this.state.logInMember}
              logInOrg={this.state.logInOrg}
              memberSignIn={this.memberSignIn}
              orgSignIn={this.orgSignIn}
              logOut={this.handleSignOut}
              user={this.state.user} />
          </header>
          <main>
            <Switch>
              <Route exact path='/' render={() => (<HomePage
                data={allData}
                firebaseData={firebaseData}
                logInMember={this.state.logInMember}
                logInOrg={this.state.logInOrg}
                fav={fav}
                saveFav={this.saveFav}
                user={this.state.user} />)} />

              <Route exact path='/browse' render={() => (<BrowsePage
                data={allData}
                firebaseData={firebaseData}
                logInMember={this.state.logInMember}
                logInOrg={this.state.logInOrg}
                fav={fav}
                saveFav={this.saveFav}
                user={this.state.user} />)} />

              <Route path='/programs/:programID' render={(routerProps) => (<ProgramDetailPage {...routerProps}
                firebaseData={firebaseData}
                data={allData}
                logInMember={this.state.logInMember}
                fav={fav}
                saveFav={this.saveFav}
                submit={this.handleSubmit}
                user={this.state.user} />)} />

              <Route path='/myPage' render={() => (<MyPage
                data={allData}
                firebaseData={firebaseData}
                logInMember={this.state.logInMember}
                logInOrg={this.state.logInOrg}
                fav={fav}
                saveFav={this.saveFav}
                user={this.state.user} />)} />

              <Route path='/myOrgPage' render={() => (<MyOrgPage
                data={allData}
                firebaseData={firebaseData}
                logInOrg={this.state.logInOrg}
                fav={fav}
                saveFav={this.props.saveFav}
                addProgram={this.addProgram}
                writeNewProgram={this.writeNewProgram}
                removeEvent={this.removeEvent}
                removeProgram={this.removeProgram}
                user={this.state.user} />)} />

              <Route path='/aboutUs' render={() => (<AboutPage />)} />
              <Route path='/howSpeNeedsWorks' render={() => (<HowSpeNeedsWorks />)} />
              <Route path='/policyPage' render={() => (<PolicyPage />)} />
              <Route path='/policyOrgPage' render={() => (<PolicyOrgPage />)} />
              <Route path='/faqs' render={() => (<Faqs />)} />

              <Redirect to="/" />
            </Switch>
          </main>
          <Footer logInMember={this.state.logInMember} logInOrg={this.state.logInOrg} />
        </div >
      );
    }

    if (this.state.error) {
      return (
        <div><p>Error: Please check</p></div>
      );
    } else if (!this.state.isloaded) {
      return (
        <div className="mr-auto ml-auto">
          <p className="spinner-p">Loading...</p>
          <Spinner className="spinner" style={{ width: '35rem', height: '35rem' }} type="grow" />
        </div>
      );
    } else {
      return (
        <div>
          {content}
        </div>
      );
    }
  }
}

// Home Page
class HomePage extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    let programData = this.props.firebaseData.programs; //[] empty array will display "No Programs Available"
    let eventData = this.props.firebaseData.events;

    return (
      <div id="homePage">
        <section id="event-gallery">
          <CarouselDisplay data={programData} />
        </section>
        <section id="program-list">
          <FeaturedPrograms data={programData} title="Featured Programs" viewAll="false" logInMember={this.props.logInMember} logInOrg={this.props.logInOrg} fav={this.props.fav} saveFav={this.props.saveFav} user={this.props.user} />
        </section>
        <section id="event-list">
          <Events data={eventData} title="Featured Events" viewAll="false" logInOrg={this.props.logInOrg} user={this.props.user}></Events>
        </section>
      </div>
    );
  }
}

// Browse Page
class BrowsePage extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    let programData = this.props.firebaseData.programs;
    let eventData = this.props.firebaseData.events;
    return (
      <div id="browsePage">
        <section id="program-list">
          <FeaturedPrograms data={programData} title="All Programs" viewAll="true" logInMember={this.props.logInMember} logInOrg={this.props.logInOrg} fav={this.props.fav} saveFav={this.props.saveFav} user={this.props.user} />
        </section>
        <section id="event-list">
          <Events data={eventData} title="All Events" viewAll="true" logInOrg={this.props.logInOrg} user={this.props.user}></Events>
        </section>
      </div>
    );
  }
}

// About Page
export class AboutPage extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <div id="aboutPage" className="m-0">
        <OurStory />
        <WhatWePropose />
      </div>
    );
  }
}

export default App;
